import { Building2, Calendar, User, ArrowRight, Activity, Shield } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { formatEuro, formatDate } from "@/sales/lib/api";

export default function DealCard({ deal, isDragging, compact = false, onClick }) {
  const navigate = useNavigate();
  const handleVoortgang = (e) => {
    e.stopPropagation();
    navigate(`/sales/traject/${deal.id}/voortgang`);
  };
  return (
    <div
      onClick={onClick}
      data-testid={`deal-card-${deal.id}`}
      className={`deal-card bg-[#1C3A5A] rounded-md p-3.5 mb-2.5 border ${
        isDragging
          ? "border-[#C0C0C0] shadow-2xl rotate-1"
          : "border-[rgba(192,192,192,0.18)] hover:border-[#C0C0C0]/60"
      } cursor-grab active:cursor-grabbing select-none`}
    >
      <div className="flex items-start justify-between gap-2 mb-2">
        <div className="flex items-start gap-1.5 min-w-0 flex-1">
          <Building2 size={14} className="text-[#C0C0C0] mt-0.5 flex-shrink-0" />
          <h4 className="font-serif-display text-sm font-medium text-[#F8FAFC] leading-tight truncate">
            {deal.municipality}
          </h4>
        </div>
        <p className="font-serif-display text-sm font-semibold text-[#C0C0C0] tabular-nums whitespace-nowrap">
          {formatEuro(deal.value)}
        </p>
      </div>

      {deal.eigenaar && (
        <div
          data-testid={`deal-eigenaar-${deal.id}`}
          className="inline-flex items-center gap-1 text-[9px] uppercase tracking-[0.16em] font-semibold text-[#0B1521] bg-[#C0C0C0] rounded-full px-2 py-0.5 mb-2"
        >
          <Shield size={9} />
          {deal.eigenaar}
        </div>
      )}

      {!compact && (
        <>
          {deal.last_action && (
            <div className="text-[11px] text-[#94A3B8] mt-2 line-clamp-2">
              <span className="text-[#64748B] uppercase tracking-wider text-[9px] block">Last</span>
              {deal.last_action}
            </div>
          )}

          {deal.next_action && (
            <div className="mt-2 pt-2 border-t border-[rgba(192,192,192,0.1)]">
              <div className="flex items-center gap-1.5 mb-1">
                <ArrowRight size={11} className="text-emerald-400" />
                <span className="text-[9px] uppercase tracking-wider text-[#64748B]">Next</span>
              </div>
              <p className="text-[11px] text-[#E2E8F0] line-clamp-2 leading-snug">
                {deal.next_action}
              </p>
              <div className="flex items-center gap-3 mt-1.5 text-[10px] text-[#94A3B8]">
                {deal.owner && (
                  <span className="flex items-center gap-1">
                    <User size={10} /> {deal.owner}
                  </span>
                )}
                {deal.next_action_date && (
                  <span className="flex items-center gap-1">
                    <Calendar size={10} /> {formatDate(deal.next_action_date)}
                  </span>
                )}
              </div>
            </div>
          )}
        </>
      )}

      {compact && (
        <div className="flex items-center justify-between mt-1">
          {deal.owner ? (
            <p className="text-[10px] text-[#94A3B8] truncate flex-1">{deal.owner}</p>
          ) : <span />}
          <button
            type="button"
            data-testid={`voortgang-btn-${deal.id}`}
            onClick={handleVoortgang}
            onMouseDown={(e) => e.stopPropagation()}
            title="Voortgang / contactmomenten"
            className="inline-flex items-center gap-1 text-[10px] text-[#94A3B8] hover:text-[#C0C0C0] border border-[rgba(192,192,192,0.15)] rounded px-1.5 py-0.5"
          >
            <Activity size={10} />
          </button>
        </div>
      )}

      {!compact && (
        <button
          type="button"
          data-testid={`voortgang-btn-${deal.id}`}
          onClick={handleVoortgang}
          onMouseDown={(e) => e.stopPropagation()}
          className="mt-2.5 w-full inline-flex items-center justify-center gap-1.5 text-[10px] uppercase tracking-[0.16em] text-[#94A3B8] hover:text-[#C0C0C0] border border-[rgba(192,192,192,0.12)] hover:border-[rgba(192,192,192,0.4)] rounded py-1.5 transition-colors bg-[#0B1521]/40"
        >
          <Activity size={11} />
          Voortgang / contactmomenten
        </button>
      )}
    </div>
  );
}
